export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Get admin token from localStorage
export const getAdminToken = () => localStorage.getItem('admin_token');

// Get admin user from localStorage
export const getAdminUser = () => {
  const user = localStorage.getItem('admin_user');
  return user ? JSON.parse(user) : null;
};

// Set admin auth data
export const setAdminAuth = (token, user) => {
  localStorage.setItem('admin_token', token);
  localStorage.setItem('admin_user', JSON.stringify(user));
};

// Clear admin auth data
export const clearAdminAuth = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
};

// Check if admin is authenticated
export const isAuthenticated = () => {
  return !!getAdminToken();
};

// Check if admin is super admin
export const isSuperAdmin = () => {
  const user = getAdminUser();
  return user?.is_super_admin === true;
};

// Fetch with admin authorization
export const fetchWithAuth = async (url, options = {}) => {
  const token = getAdminToken();

  const headers = {
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Only set Content-Type if not FormData
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(`${API_URL}${url}`, {
    ...options,
    headers,
  });

  // Handle 401 unauthorized - redirect to login
  if (response.status === 401) {
    clearAdminAuth();
    window.location.href = '/login';
    throw new Error('Session expired');
  }

  if (!response.ok) {
    // Some failures (a proxy error, a crash before the JSON body) are not JSON
    // at all; fall back rather than throwing a SyntaxError over the real cause.
    let payload = {};
    try {
      payload = await response.json();
    } catch (_) {
      payload = {};
    }
    const err = new Error(payload.message || `Request failed (${response.status})`);
    // The stable machine code the UI translates on, and the status for callers
    // that need to distinguish 403 from 409 without string-matching.
    err.code = payload.code;
    err.status = response.status;
    err.payload = payload;
    throw err;
  }

  return response;
};

// Helper for GET requests
export const apiGet = async (url) => {
  const response = await fetchWithAuth(url);
  return response.json();
};

// Helper for POST requests
export const apiPost = async (url, data) => {
  const isFormData = data instanceof FormData;
  const response = await fetchWithAuth(url, {
    method: 'POST',
    body: isFormData ? data : JSON.stringify(data),
  });
  return response.json();
};

// Helper for PUT requests
export const apiPut = async (url, data) => {
  const isFormData = data instanceof FormData;
  const response = await fetchWithAuth(url, {
    method: 'PUT',
    body: isFormData ? data : JSON.stringify(data),
  });
  return response.json();
};

// Helper for DELETE requests
export const apiDelete = async (url) => {
  const response = await fetchWithAuth(url, {
    method: 'DELETE',
  });
  return response.json();
};

// Format date for display
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

// Format datetime for display
export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
